import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Production'da gelistirme ciktilari konsola dusmesin: oturum/token durumu,
// kullanici adi ve cache ayrintilari gibi bilgiler tarayici konsolunda gorunuyordu.
// Gercek hata kanallari (warn/error) acik kalir.
if (process.env.NODE_ENV === 'production') {
  const sessiz = () => {};
  console.log = sessiz;
  console.debug = sessiz;
  console.info = sessiz;
  console.table = sessiz;
  console.trace = sessiz;
  console.dir = sessiz;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
);
